// Application configuration constants
export const APP_CONFIG = {
  // Application title - can be overridden by environment variable
  APP_TITLE: process.env.REACT_APP_TITLE || 'Dining-x Talabat',
  APP_SHORT_NAME: process.env.REACT_APP_SHORT_NAME || 'Dining-x Talabat',
  APP_DESCRIPTION: process.env.REACT_APP_DESCRIPTION || 'Dining-x Talabat Integration - A seamless dining experience with Talabat',
  
  // Version information
  APP_VERSION: process.env.REACT_APP_VERSION || 'v1.0',
  
  // Login page specific titles
  LOGIN_TITLE: process.env.REACT_APP_LOGIN_TITLE || 'Dining-x Talabat',
  LOGIN_SUBTITLE: process.env.REACT_APP_LOGIN_SUBTITLE || 'Sign in to access the Dining-x Talabat Integration',
  LOGIN_FOOTER: process.env.REACT_APP_LOGIN_FOOTER || 'Dining-x Talabat Integration v1.0',
  
  // Main layout titles
  SIDEBAR_TITLE: process.env.REACT_APP_SIDEBAR_TITLE || 'Dining-x Talabat',
  DEFAULT_PAGE_TITLE: process.env.REACT_APP_DEFAULT_PAGE_TITLE || 'Talabat Integration Manager',
    // App icon configuration
  USE_ICON_IN_SIDEBAR: process.env.REACT_APP_USE_SIDEBAR_ICON !== 'false', // Default to true unless explicitly set to false
  USE_APP_ICON_IN_LOGIN: process.env.REACT_APP_USE_APP_ICON_IN_LOGIN === 'true', // Default to false (keep lock icon)
} as const;

// Helper function to get the full app title for document.title
export const getDocumentTitle = (pageTitle?: string): string => {
  if (pageTitle && pageTitle !== APP_CONFIG.APP_TITLE) {
    return `${pageTitle} | ${APP_CONFIG.APP_TITLE}`;
  }
  return APP_CONFIG.APP_TITLE;
};

// Helper function to get environment-specific styling
export const getAppTheme = () => {
  const environment = process.env.NODE_ENV;
  const customTheme = process.env.REACT_APP_THEME_PRIMARY_COLOR;
  
  return {
    environment,
    primaryColor: customTheme || '#1976d2',
    isProduction: environment === 'production',
    isDevelopment: environment === 'development',
  };
};
